'use client'
import React from 'react'
import classNames from 'classnames'
import {
  getTwoLetterISOLanguageName,
  Language,
  constants,
  UserSettings,
  getCultureCode,
} from '@dustin-web/microsite-config'
import { useCookieState } from '@dustin-web/microsite-components/src/hooks/use-cookie-state'
import Cookies from 'universal-cookie'

const cookies = new Cookies()
const ONE_YEAR = 365 * 24 * 60 * 60

type SiteLangSwitchButton = {
  lang: Language
  language: Language
  selectedContactId?: string | null
  showPricesInclVat: boolean
  personalizationConsent: boolean
}

const SiteLangSwitchButton = ({
  lang,
  language,
  selectedContactId,
  showPricesInclVat,
  personalizationConsent,
}: SiteLangSwitchButton) => {
  const twoLetterISOLanguageName = getTwoLetterISOLanguageName(lang)
  const cookieState = useCookieState()

  const setLanguage = (language: Language) => {
    const isPunchout = !!cookieState.cookies.punchOutTicket

    if (isPunchout) {
      cookies.set(constants.cookies.userSettings.language, getCultureCode(language), {
        maxAge: ONE_YEAR,
        path: '/',
        sameSite: 'none' as 'none' | 'lax',
        secure: true,
      })
    } else {
      cookies.set(constants.cookies.userSettings.language, getCultureCode(language), {
        maxAge: ONE_YEAR,
        path: '/',
      })
    }

    const userParams: UserSettings = {
      language,
      selectedContactId,
      showPricesInclVat,
      personalizationConsent,
    }

    cookies.set(constants.cookies.userParams, userParams, {
      maxAge: ONE_YEAR,
      path: '/',
    })

    window.location.reload()
  }
  return (
    <button
      data-ga-title={`lang-switcher-${twoLetterISOLanguageName}`}
      className={classNames('c-header__site-lang-switcher-link u-mb-0 button-stripped', {
        'c-header__site-lang-switcher-link--active': language === lang,
      })}
      onClick={() => setLanguage(lang)}>
      {twoLetterISOLanguageName.toUpperCase()}
    </button>
  )
}

export default SiteLangSwitchButton
